"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 在数组中查找元素
 * @param items
 * @param callback
 */
exports.find = function (items, callback) {
    for (var i = 0, length_1 = items.length; i < length_1; i++)
        if (callback(items[i], i))
            return items[i];
};
/**
 * 传入值和值所对应字段的
 * 校验值是否正确
 * 并返回正确值
 * @param {*} val
 * @param {*} param1
 */
exports.getCorrectVal = function (val, _a) {
    var enumeration = _a.enumeration, minValue = _a.minValue, maxValue = _a.maxValue;
    if (enumeration && enumeration.length) {
        return exports.find(enumeration, function (item) { return item.value === val; }) ? val : enumeration[0].value;
    }
    if (minValue !== undefined && val < minValue)
        return minValue;
    if (maxValue !== undefined && val > maxValue)
        return maxValue;
    return val;
};
/**
 * 根据字段信息计算出字段默认值
 * @param {*} param0
 */
exports.getValFromProtocol = function (_a) {
    var enumeration = _a.enumeration, minValue = _a.minValue, maxValue = _a.maxValue, dataLength = _a.dataLength;
    if (enumeration && enumeration.length)
        return enumeration[0].value;
    if (minValue !== undefined)
        return minValue;
    if (maxValue !== undefined)
        return maxValue;
    // 随机产生指定数据长度的数值
    return Math.floor(Math.random() * Math.pow(16, dataLength * 2));
};
/**
 * 10进制转为16进制
 * @param dec
 * @param length
 */
exports.decToHex = function (dec, length) {
    if (length === void 0) { length = 1; }
    var hex = dec.toString(16);
    while (length * 2 > hex.length)
        hex = "0" + hex;
    return hex.slice(-length * 2);
};
/**
 * 16进制转10进制
 * @param hex
 */
exports.hexToDec = function (hex) { return parseInt(hex, 16); };
/**
 * 把字符串按指定长度分割为数组
 * @param raw
 * @param length
 */
exports.splitByLength = function (raw, length) {
    if (length === void 0) { length = 2; }
    var arr = raw.split('');
    var data = [];
    while (arr.length)
        data.push(arr.splice(0, length).join(''));
    return data;
};
/**
 * 在字符串前面补0，直到长度到达某个值
 * @param raw
 * @param length
 */
exports.paddStartZero = function (raw, length) {
    if (length === void 0) { length = 0; }
    while (raw.length < length)
        raw = "0" + raw;
    return raw;
};
/**
 * 创建指定长度的数组，并填充指定值
 * @param length
 * @param fill
 */
exports.creatArrayAndFill = function (length, fill) {
    if (length === void 0) { length = 0; }
    var arr = [];
    while (length > arr.length)
        arr.push(fill);
    return arr;
};
/**
 * 把字符串转换为utf8编码字节数组
 * @param raw
 */
exports.rawToUTF8Bytes = function (raw) {
    var utf8 = [];
    var i = 0;
    while (i < raw.length) {
        var charCode = raw.charCodeAt(i);
        if (charCode < 0x80) {
            // ascii码直接转换
            utf8.push(charCode);
            i += 1;
        }
        else if (charCode < 0x800) {
            // 两个字节表示一个字符
            utf8.push(0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f));
            i += 1;
        }
        else if (charCode < 0xd800 || charCode >= 0xe000) {
            // 三个字节表示一个字符的情况
            utf8.push(0xe0 | (charCode >> 12), 0x80 | ((charCode >> 6) & 0x3f), 0x80 | (charCode & 0x3f));
            i += 1;
        }
        else {
            // 4个字节表示一个字符的情况
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charCode = 0x10000 + (((charCode & 0x3ff) << 10) | (raw.charCodeAt(i) & 0x3ff));
            utf8.push(0xf0 | (charCode >> 18), 0x80 | ((charCode >> 12) & 0x3f), 0x80 | ((charCode >> 6) & 0x3f), 0x80 | (charCode & 0x3f));
            i += 2;
        }
    }
    return utf8;
};
/**
 * 把utf8字节数组还原为字符
 * @param UTF8Bytes
 */
exports.UTF8BytesToRaw = function (UTF8Bytes) {
    var raw = '';
    var i = 0;
    while (i < UTF8Bytes.length) {
        var charCode = UTF8Bytes[i];
        if (charCode < 0x80) {
            raw += String.fromCharCode(charCode);
            i += 1;
        }
        else if (charCode > 0xbf && charCode < 0xe0) {
            charCode = (charCode & 0x1f) << 6;
            charCode |= UTF8Bytes[i + 1] & 0x3f;
            raw += String.fromCharCode(charCode);
            i += 2;
        }
        else if (charCode > 0xdf && charCode < 0xf0) {
            charCode = (charCode & 0x0f) << 12;
            charCode |= (UTF8Bytes[i + 1] & 0x3f) << 6;
            charCode |= UTF8Bytes[i + 2] & 0x3f;
            raw += String.fromCharCode(charCode);
            i += 3;
        }
        else {
            // surrogate pair
            charCode = (charCode & 0x07) << 18;
            charCode |= (UTF8Bytes[i + 1] & 0x3f) << 12;
            charCode |= (UTF8Bytes[i + 2] & 0x3f) << 6;
            charCode |= UTF8Bytes[i + 3] & 0x3f;
            charCode -= 0x010000;
            raw += String.fromCharCode((charCode >> 10) | 0xd800, (charCode & 0x03ff) | 0xdc00);
            i += 4;
        }
    }
    return raw;
};



// WEBPACK FOOTER //
// ./src/utils.ts